import { render, staticRenderFns } from "./userSetup.vue?vue&type=template&id=7a087e02"
import script from "./userSetup.vue?vue&type=script&lang=js"
export * from "./userSetup.vue?vue&type=script&lang=js"
import style0 from "./userSetup.vue?vue&type=style&index=0&id=7a087e02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports